( function( $ ) {

$( function() {

	var page = $('#page-forgot-password');
	if (page.length < 1) {
		return;
	}

	page.on('ajax:success', 'form.form', function( e, result ) {
		var email = $( '#email' ).val(),
			boxEl = $('.box').empty();
		$(simple.tpl($('#template-email-sent').html(), {
			email: email
		})).appendTo(boxEl);
	});

});

})( jQuery );
